import { compact, isNil, negate } from 'lodash-es'

import { toFormattedDate } from '../util/date'
import { VehicleVIN } from './types'

export const toVehicleDescriptionVIN = ({ make, model, trim }: VehicleVIN): string =>
  compact([make, model, trim]).join(' ')

export const toVehicleFuelDescriptionVIN = ({
  primaryFuel,
  secondaryFuel,
}: VehicleVIN): string =>
  secondaryFuel ? `${primaryFuel}/${secondaryFuel}` : primaryFuel

export const toVehicleYearRangeVIN = ({
  rangeStartYear,
  rangeEndYear,
}: VehicleVIN): string => `${rangeStartYear}-${rangeEndYear ?? 'Present'}`

export const toVehicleManufacturePeriodVIN = ({
  startDate,
  endDate,
}: VehicleVIN): string | undefined =>
  startDate && endDate
    ? `${toFormattedDate(startDate)} to ${toFormattedDate(endDate)}`
    : startDate
    ? `${toFormattedDate(startDate)} onwards`
    : undefined

const toEngineCapacityInLitresVIN = (capacity: number | null | undefined) =>
  capacity ? `${(Math.round(capacity / 100.0) / 10).toFixed(1)}-litre` : undefined

export const toVehicleEngine = ({
  engineCapacity,
  engineLabel,
}: VehicleVIN): string | undefined =>
  [toEngineCapacityInLitresVIN(engineCapacity), engineLabel]
    .filter(negate(isNil))
    .join(' ') || undefined

export const toVehicleEnginePowerVIN = ({
  enginePower,
}: VehicleVIN): string | undefined =>
  enginePower ? `${Math.round(enginePower * 1.01387)} PS` : undefined
